<template>
	<v-row class="mt-5">
		<v-col>
			<v-card class="pa-4"  v-if="userDetails">
				<v-card-title>My Info</v-card-title>
				<v-card-text>
					<v-row>
						<v-col>
							<v-text-field
							class="mb-0"
							placeholder="First Name" 
							v-model="userDetails.firstName" v-on:change="displayNameChanged = true"></v-text-field>
						</v-col>
						<v-col>
							<v-text-field
							class="mb-0"
							placeholder="Last Name" 
							v-model="userDetails.lastName" v-on:change="displayNameChanged = true"></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field
							class="mb-0"
							placeholder="Main Phone Number" 
							v-model="userDetails.phone"></v-text-field>
						</v-col>
						<v-col>
							<v-text-field
							class="mb-0"
							placeholder="Alternative Phone Number" 
							v-model="userDetails.alternativePhone"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green" dark v-on:click="updateUser">Update details</v-btn>
				</v-card-actions>

			</v-card>
			<v-card class="mt-5 pa-4">
				<v-card-title>Email</v-card-title>
				<v-card-text>
					
				<v-row>
					<v-col>
						<v-text-field
						class="mb-0"
						placeholder="Email Address" 
						v-model="email"></v-text-field>
					</v-col>
					<v-col>
						<v-text-field
						class="mb-0"
						placeholder="Repeat Email Address" 
						v-model="repeatEmail"></v-text-field>
					</v-col>
				</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green" dark v-on:click="updateEmail" :disabled="!(email && repeatEmail)">Update email </v-btn>
				</v-card-actions>
			</v-card>
			<v-card class="mt-5 pa-4">
				<v-card-title>Password</v-card-title>
				<v-card-text>
				<v-text-field placeholder="Password" 
					v-model="password" 
					type="password"></v-text-field>
					<v-text-field placeholder="Repeat Password" 
					v-model="repeatPassword"
					type="password"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green" dark v-on:click="updatePassword" :disabled="!(password && repeatPassword)">Update login </v-btn>
				</v-card-actions>
			</v-card>
			<TimeZoneSelector :user="userDetails" class="mt-4"></TimeZoneSelector>
		</v-col>
		<v-snackbar v-model="clicked" light>
			{{message}}
			<v-btn color="accent" text @click="clicked = false">Close </v-btn>
		</v-snackbar>
	</v-row>
</template>

<script>
import TimeZoneSelector from "../components/tools/TimeZoneSelector.vue"
import Vuex from "vuex";
export default {
	name: "Profile",
	data() {
		return {
			password: "",
			repeatPassword: "",
			message: "",
			clicked: false,
			email: "", 
			repeatEmail: "",
			displayNameChanged: false
		};
	},
	components: {
		TimeZoneSelector: TimeZoneSelector
	},
	computed: {
		...Vuex.mapState({
			userDetails: state => state[state.auth.view].user, 
			user: state => state.auth.user
		})
	},
	created: function(){
		this.$store.dispatch("fetchUser")
		if( this.user ){
			this.email = this.user.email;
		}		


	}, 
	methods: {
		async updateDisplayName(){
			var self = this;
			return new Promise((resolve, reject) => {				
				if( self.displayNameChanged ){
					self.user.updateProfile({
						displayName: self.userDetails.displayName
					}).then( () => {
						resolve( self.displayName )
					}).catch( (e) => {
						reject(e)
					})
				}
				else{
					resolve( false )
				}
			})

		},
		updateUser: function(){
			var self = this;
			var userDetails = self.userDetails;
			self.updateDisplayName( ).then( newDisplayName => {
				userDetails.displayName = newDisplayName;
				self.$store.dispatch("updateDoc", {
					doc: "users/" + self.user.uid,
					data: userDetails, 
					action: "update"
				}).then( () => {
					self.clicked = true;
					self.message = "Name changed";
				}).catch(function(error) {
					self.message = error;
					self.clicked = true;
				});
			})
		},
		updateEmail: function(){
			var self = this;
			if( self.email !== self.repeatEmail ){
				self.clicked = true;
				self.message = "Email mismatch!"
				return;
			}
			self.user.updateEmail(self.email).then(function() {
				self.$store.dispatch("updateDoc", {
					doc: "users/" + self.user.uid,
					data: {email: self.email }, 
					action: "update"
				})
				self.clicked = true;
				self.message = "Email changed";
			}).catch(function(error) {
				if( error.code == "auth/requires-recent-login" ){
					self.message = error.message
				}
				else{
					self.message = "Something went wrong."
				}
				self.clicked = true;
			});
		},
		updatePassword: function(){
			var self = this;
			if( self.password !== self.repeatPassword ){
				self.clicked = true;
				self.message = "Password mismatch!"
			}
			else{
				self.user.updatePassword(self.password).then(function() {
					self.clicked = true;
					self.message = "Password changed";
				}).catch(function(error) {
					if( error.code == "auth/requires-recent-login" ){
						self.message = error.message
					}
					else{
						self.message = "Something went wrong."
					}
					self.clicked = true;
				});
			}

		}
	}, 

};
</script>


